export function parseCapacitiesInString(text: string ): Array<[string, string, string]> {
    const matches = text.matchAll(/\[([a-z]*)\|([-0-9]*)\]/g);
    const arr = [...matches];
    return arr as Array<[string, string, string]>;
}